import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { toast } from 'react-toastify';
import './LocateControl.css'; // Assurez-vous d'importer le fichier CSS

const LocateControl = ({ position = 'bottomright' }) => {
  const map = useMap();
  const locationMarkerRef = useRef(null);

  useEffect(() => {
    // Créer un style personnalisé pour le marqueur de localisation
    const locationIcon = L.divIcon({
      className: 'location-marker',
      html: '<div class="location-marker-inner"><div class="location-marker-circle"></div></div>',
      iconSize: [24, 24],
      iconAnchor: [12, 12]
    });

    // Créer un contrôle personnalisé
    const locateControl = L.Control.extend({
      options: {
        position: position
      },
      
      onAdd: function() {
        const container = L.DomUtil.create('div', 'leaflet-bar');
        const button = L.DomUtil.create('button', 'leaflet-control-button', container);
        button.title = 'Me localiser';
        
        // Créer directement le point de localisation dans le bouton
        L.DomUtil.create('span', 'location-dot', button);
        
        L.DomEvent.on(button, 'click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          button.classList.add('locating');
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const latlng = [position.coords.latitude, position.coords.longitude];
                
                // Supprimer l'ancien marqueur s'il existe
                if (locationMarkerRef.current) {
                  map.removeLayer(locationMarkerRef.current);
                }

                // Créer et ajouter le nouveau marqueur
                locationMarkerRef.current = L.marker(latlng, { icon: locationIcon }).addTo(map);
                
                map.setView(latlng, 16, { animate: true });
                button.classList.remove('locating');
                button.classList.add('located');
                setTimeout(() => button.classList.remove('located'), 2000);
              },
              (error) => {
                button.classList.remove('locating');
                if (error.code === 1) {
                  toast.error("Vous avez refusé l'accès à la géolocalisation. Veuillez autoriser l'accès dans les paramètres de votre navigateur.");
                } else {
                  toast.error("Une erreur est survenue lors de la récupération de votre position.");
                }
                console.error("Erreur lors de la récupération de la position de l'utilisateur", error);
              }
            );
          } else {
            button.classList.remove('locating');
            toast.error("La géolocalisation n'est pas supportée par votre navigateur.");
          }
        });

        return container;
      }
    });

    // Ajouter le contrôle à la carte
    const control = new locateControl();
    map.addControl(control);

    // Nettoyer lors du démontage du composant
    return () => {
      map.removeControl(control);
      if (locationMarkerRef.current) {
        map.removeLayer(locationMarkerRef.current);
      }
    };
  }, [map, position]);

  return null;
};

export default LocateControl;
